var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-friend-wrapper d-none"},[_c('button',{staticClass:"btn invite-friends",on:{"click":function($event){return _vm.callModal()}}},[_c('img',{staticClass:"mr-3",attrs:{"src":require("../../assets/invite.png"),"alt":""}}),_vm._v(" Invite Friends ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }